(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["logo-carousel"] && !Shopify.designMode) return;
  try {
    
var logoCarousel = (function(){
	var prev = '<svg xmlns="http://www.w3.org/2000/svg" width="7" height="10" viewBox="0 0 7 10" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M5.14398 9.5L6.20148 8.4425L2.76648 5L6.20148 1.5575L5.14398 0.5L0.643977 5L5.14398 9.5Z" fill="#616161"/></svg>';
  var next = '<svg xmlns="http://www.w3.org/2000/svg" width="7" height="10" viewBox="0 0 7 10" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M1.85608 0.5L0.798584 1.5575L4.23358 5L0.798584 8.4425L1.85608 9.5L6.35608 5L1.85608 0.5Z" fill="#616161"/></svg>';
  return {
    init: function () {
      $(".logo__carousel").owlCarousel({
        loop:true,
        autoWidth:true,
        margin:10,
        responsiveClass:true,
        responsive:{
          0:{
            items:2,
            nav:false,
            navText: [prev, next],
            loop:false
          },
          414:{
            items:3,
            nav:true,
            navText: [prev, next],
            loop:false
          },
          768:{
            items:5,
            nav:true,
            navText: [prev, next],
            loop:false
          }
        }
      })
    }
  }
}());
logoCarouselLoad = function(evt) {
  switch ( evt.originalEvent.type ) {
    case "shopify:section:load" :
      logoCarousel.init();
      break;
  }  
};
$(document).ready(logoCarousel.init);
$(document).on('shopify:section:load', logoCarouselLoad);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["logo-carousel_four"] && !Shopify.designMode) return;
  try {
    
var logoCarousel = (function(){
	var prev = '<svg xmlns="http://www.w3.org/2000/svg" width="7" height="10" viewBox="0 0 7 10" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M5.14398 9.5L6.20148 8.4425L2.76648 5L6.20148 1.5575L5.14398 0.5L0.643977 5L5.14398 9.5Z" fill="#616161"/></svg>';
    var next = '<svg xmlns="http://www.w3.org/2000/svg" width="7" height="10" viewBox="0 0 7 10" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M1.85608 0.5L0.798584 1.5575L4.23358 5L0.798584 8.4425L1.85608 9.5L6.35608 5L1.85608 0.5Z" fill="#616161"/></svg>';
 
    return {
        init: function () {
              $(".logo__carousel").owlCarousel({
              loop:true,
autoWidth:true,
              margin:10,
              responsiveClass:true,
              responsive:{
                  0:{
                      items:2,
                      nav:false,
                      navText: [prev, next],
                      loop:false
                  },
                  414:{
                      items:3,
                      nav:true,
                      navText: [prev, next],
                      loop:false
                  },
                  768:{
                      items:5,
                      nav:true,
                      navText: [prev, next],
                      loop:false
                  }
              }
            })
        }
    }

}());

logoCarouselLoad = function(evt) {
  switch ( evt.originalEvent.type ) {
    case "shopify:section:load" :
      logoCarousel.init();
      break;
  }  
};

$(document).ready(logoCarousel.init);
$(document).on('shopify:section:load', logoCarouselLoad);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["logo-carousel_three"] && !Shopify.designMode) return;
  try {
    
var logoCarousel = (function(){
	var prev = '<svg xmlns="http://www.w3.org/2000/svg" width="7" height="10" viewBox="0 0 7 10" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M5.14398 9.5L6.20148 8.4425L2.76648 5L6.20148 1.5575L5.14398 0.5L0.643977 5L5.14398 9.5Z" fill="#616161"/></svg>';
    var next = '<svg xmlns="http://www.w3.org/2000/svg" width="7" height="10" viewBox="0 0 7 10" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M1.85608 0.5L0.798584 1.5575L4.23358 5L0.798584 8.4425L1.85608 9.5L6.35608 5L1.85608 0.5Z" fill="#616161"/></svg>';
 
    return {
        init: function () {
              $(".logo__carousel").owlCarousel({
              loop:true,
autoWidth:true,
              margin:10,
              responsiveClass:true,
              responsive:{
                  0:{
                      items:2,
                      nav:false,
                      navText: [prev, next],
                      loop:false
                  },
                  414:{
                      items:3,
                      nav:true,
                      navText: [prev, next],
                      loop:false
                  },
                  768:{
                      items:5,
                      nav:true,
                      navText: [prev, next],
                      loop:false
                  }
              }
            })
        }
    }

}());

logoCarouselLoad = function(evt) {
  switch ( evt.originalEvent.type ) {
    case "shopify:section:load" :
      logoCarousel.init();
      break;
  }  
};

$(document).ready(logoCarousel.init);
$(document).on('shopify:section:load', logoCarouselLoad);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["logo-carousel_two"] && !Shopify.designMode) return;
  try {
    
var logoCarousel = (function(){
	var prev = '<svg xmlns="http://www.w3.org/2000/svg" width="7" height="10" viewBox="0 0 7 10" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M5.14398 9.5L6.20148 8.4425L2.76648 5L6.20148 1.5575L5.14398 0.5L0.643977 5L5.14398 9.5Z" fill="#616161"/></svg>';
    var next = '<svg xmlns="http://www.w3.org/2000/svg" width="7" height="10" viewBox="0 0 7 10" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M1.85608 0.5L0.798584 1.5575L4.23358 5L0.798584 8.4425L1.85608 9.5L6.35608 5L1.85608 0.5Z" fill="#616161"/></svg>';
 
    return {
        init: function () {
              $(".logo__carousel").owlCarousel({
              loop:true,
autoWidth:true,
              margin:10,
              responsiveClass:true,
              responsive:{
                  0:{
                      items:2,
                      nav:false,
                      navText: [prev, next],
                      loop:false
                  },
                  414:{
                      items:3,
                      nav:true,
                      navText: [prev, next],
                      loop:false
                  },
                  768:{
                      items:5,
                      nav:true,
                      navText: [prev, next],
                      loop:false
                  }
              }
            })
        }
    }

}());

logoCarouselLoad = function(evt) {
  switch ( evt.originalEvent.type ) {
    case "shopify:section:load" :
      logoCarousel.init();
      break;
  }  
};

$(document).ready(logoCarousel.init);
$(document).on('shopify:section:load', logoCarouselLoad);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
$(document).ready(function() {
  var prev = '<svg width="30px" height="30px" viewBox="0 0 50 80" xml:space="preserve"><polyline fill="none" stroke="#000000" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" points="45.63,75.8 0.375,38.087 45.63,0.375 "/></svg>';
  var next = '<svg width="30px" height="30px" viewBox="0 0 50 80" xml:space="preserve"><polyline fill="none" stroke="#000000" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" points="0.375,0.375 45.63,38.087 0.375,75.8 "/></svg>';

  $('.owl-carousel').owlCarousel({
    loop:true,
    margin:10,
    responsiveClass:true,
    responsive:{
        0:{
            items:2,
            nav:false,
            navText: [prev, next],
            loop:false,
			dots: false
        },
        414:{
            items:3,
            nav:true,
            navText: [prev, next],
            loop:false,
			dots: false
        },
        768:{
            items:4,
            nav:false,
            navText: [prev, next],
            loop:false,
			dots: false
        }
    }
  })
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials-custom"] && !Shopify.designMode) return;
  try {
    
var testimonialsCarousel = (function(){
	var prev = '<svg width="30px" height="30px" viewBox="0 0 50 80" xml:space="preserve"><polyline fill="none" stroke="#000000" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" points="45.63,75.8 0.375,38.087 45.63,0.375 "/></svg>';
    var next = '<svg width="30px" height="30px" viewBox="0 0 50 80" xml:space="preserve"><polyline fill="none" stroke="#000000" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" points="0.375,0.375 45.63,38.087 0.375,75.8 "/></svg>';

    return {
        init: function () {
            $(".testimonials").owlCarousel({
              loop:true,
              items: 1
            })
        }
    }

}());

$(document).ready(function () {
	testimonialsCarousel.init();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["upsell-products"]) return;
  try {
    
$(document).ready(function() {
  var prev = '<svg width="30px" height="30px" viewBox="0 0 50 80" xml:space="preserve"><polyline fill="none" stroke="#000000" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" points="45.63,75.8 0.375,38.087 45.63,0.375 "/></svg>';
  var next = '<svg width="30px" height="30px" viewBox="0 0 50 80" xml:space="preserve"><polyline fill="none" stroke="#000000" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" points="0.375,0.375 45.63,38.087 0.375,75.8 "/></svg>';

  $('.owl-carousel').owlCarousel({
    loop:true,
    margin:10,
    responsiveClass:true,
    responsive:{
        0:{
            items:2,
            nav:false,
            navText: [prev, next],
            loop:false
        },
        414:{
            items:3,
            nav:true,
            navText: [prev, next],
            loop:false
        },
        768:{
            items:4,
            nav:true,
            navText: [prev, next],
            loop:false
        }
    }
  })
});

  } catch(e) { console.error(e); }
})();
})();
